import { Checkbox } from "@material-ui/core";
import { checkPermission } from "../utils/Roles";
import { incidentAlertColor } from "./utils";
import moment from "moment";

//The idNames need to match the row names in parseInactiveIncidents
export const officerWorkQueueHeaders = [
  { title: "Badge", idName: "badge", show: true },
  { title: "Date/Time", idName: "callTime", show: true },
  { title: "Incident\xa0#", idName: "incidentNumber", show: true },
  { title: "Type", idName: "type", show: true },
  // { title: 'UOF', idName: 'useOfForce', show: true },
  { title: "Location", idName: "location", show: true },
  { title: "Rev. Status", idName: "reviewStatus", show: true },
  { title: "App. Status", idName: "approvalStatus", show: true },
  { title: "Charges", idName: "charges", show: true },
  { title: "Rev. Date", idName: "reviewDate", show: true },
  { title: "Keep in Q", idName: "keepInQueue", show: true },
  //Not sure this should show in the officer work queue
  // { title: 'Approve', idName: 'approve', show: true },
  { title: "Supervisor Notes", idName: "supervisorNotes", show: true },
];

export function parseOfficerWorkQueue(
  arr,
  keepInQueueMutationHandler,
  quickApproveHandler,
  handleIncidentOpening,
  userRoles
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((incident, incidentIndex) => {
      const badge =
        incident?.incidentReview?.investigatingOfficer?.deptAttribute?.badge;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const { locked, sealed } = incident || {};
      const callTypeColor = incidentAlertColor(incident, true, false, false);
      const locationColor = incidentAlertColor(incident, false, true, false);
      const canViewLocked = checkPermission(
        userRoles,
        "view_locked_incident",
        "ALL",
        "",
        incident?.id
      );
      const canViewSealed = checkPermission(
        userRoles,
        "view_sealed_incident",
        "ALL",
        "",
        incident?.id
      );
      const disabled =
        (!canViewLocked && locked) || (!canViewSealed && sealed) ? true : false;
      // const incidentNumber = incident?.incidentNumber
      // const incidentNumber = <button style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textDecoration: 'underline', display: 'inline', margin: '0', padding: '0', }} data-cy={"tablecell-incident-number-link-" + incident?.id} onClick={() => { handleIncidentOpening(incident?.id, true) }}>{incident?.incidentNumber}</button>
      const incidentNumber = (
        <button
          style={
            disabled
              ? {
                  backgroundColor: "transparent",
                  color: "#7d7d7d",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  border: "none",
                  display: "inline",
                  margin: "0",
                  padding: "0",
                  "&:hover": {
                    textDecoration: "none",
                  },
                  "&:focus": {
                    textDecoration: "none",
                  },
                }
              : {
                  backgroundColor: "transparent",
                  color: "#6096d1",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  border: "none",
                  cursor: "pointer",
                  textDecoration: "underline",
                  display: "inline",
                  margin: "0",
                  padding: "0",
                  "&:hover": {
                    textDecoration: "none",
                  },
                  "&:focus": {
                    textDecoration: "none",
                  },
                }
          }
          data-cy={"tablecell-incident-number-link-" + incident?.id}
          onClick={
            disabled
              ? () => alert("You do not have permission to view this incident")
              : () => {
                  handleIncidentOpening(incident?.id, true);
                }
          }
        >
          {incident?.incidentNumber}
        </button>
      );
      const type = incident?.classification?.name;
      // const uof = incident?.incidentReview?.resistanceType?.id ? "Yes" : "No"
      const location = incident?.address?.name;
      const reviewStatus = incident?.incidentReview?.reviewStatus?.name;
      const approvalStatus = incident?.incidentReview?.approvalStatus?.name;
      const charges = incident?.incidentArrests.filter(
        arrest => arrest?.arrestee?.id
      ).length;
      const reviewDate = incident?.incidentReview?.reviewDate
        ? moment
            .utc(
              incident?.incidentReview?.reviewDate,
              "YYYY-MM-DD HH:mm:ss UTC"
            )
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const keepInQueue = (
        <Checkbox
          checked={incident?.incidentReview?.keepInOfficerQueue}
          onChange={e =>
            keepInQueueMutationHandler(
              incidentIndex,
              incident.id,
              incident.incidentReview?.id,
              e?.target?.checked
            )
          }
          value={"keepInOfficerQueue"}
          color="primary"
          data-cy={"keep-in-officer-queue-checkbox"}
          inputProps={{ "data-cy": "keep-in-officer-queue-checkbox-input" }}
        />
      );
      const approve = (
        <Checkbox
          checked={
            incident?.incidentReview?.approvalStatus?.name === "Approved"
          }
          onChange={e =>
            quickApproveHandler(
              incidentIndex,
              incident.id,
              incident.incidentReview?.id,
              e?.target?.checked
            )
          }
          value={"approve"}
          color="primary"
          data-cy={"approve-checkbox"}
          inputProps={{ "data-cy": "approve-checkbox-input" }}
        />
      );
      const supervisorNotes = incident?.incidentReview?.reviewComments;
      tempRows.push(
        createOfficerData(
          badge,
          callTime,
          incidentNumber,
          type,
          location,
          reviewStatus,
          approvalStatus,
          charges,
          reviewDate,
          keepInQueue,
          approve,
          supervisorNotes,
          callTypeColor,
          locationColor
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createOfficerData(
  badge,
  callTime,
  incidentNumber,
  type,
  location,
  reviewStatus,
  approvalStatus,
  charges,
  reviewDate,
  keepInQueue,
  approve,
  supervisorNotes,
  callTypeColor,
  locationColor
) {
  return {
    badge,
    callTime,
    incidentNumber,
    type,
    location,
    reviewStatus,
    approvalStatus,
    charges,
    reviewDate,
    keepInQueue,
    approve,
    supervisorNotes,
    callTypeColor,
    locationColor,
  };
}

export const supervisorWorkQueueHeaders = [
  { title: "Badge", idName: "badge", show: true },
  { title: "Date/Time", idName: "callTime", show: true },
  { title: "Incident\xa0#", idName: "incidentNumber", show: true },
  { title: "Type", idName: "type", show: true },
  // { title: 'UOF', idName: 'useOfForce', show: true },
  { title: "Location", idName: "location", show: true },
  { title: "Rev. Status", idName: "reviewStatus", show: true },
  { title: "App. Status", idName: "approvalStatus", show: true },
  { title: "Charges", idName: "charges", show: true },
  { title: "Rev. Date", idName: "reviewDate", show: true },
  { title: "Keep in Q", idName: "keepInQueue", show: true },
  { title: "Approve", idName: "approve", show: true },
  { title: "Supervisor Notes", idName: "supervisorNotes", show: true },
];

export function parseSupervisorWorkQueue(
  arr,
  keepInQueueMutationHandler,
  quickApproveHandler,
  handleIncidentOpening
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((incident, incidentIndex) => {
      const badge =
        incident?.incidentReview?.investigatingOfficer?.deptAttribute?.badge;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      // const incidentNumber = incident?.incidentNumber
      const callTypeColor = incidentAlertColor(incident, true, false, false);
      const locationColor = incidentAlertColor(incident, false, true, false);
      const incidentNumber = (
        <button
          style={{
            backgroundColor: "transparent",
            color: "#6096d1",
            fontWeight: "bold",
            fontSize: "1rem",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
            display: "inline",
            margin: "0",
            padding: "0",
            "&:hover": {
              textDecoration: "none",
            },
            "&:focus": {
              textDecoration: "none",
            },
          }}
          data-cy={"tablecell-incident-number-link-" + incident?.id}
          onClick={() => {
            handleIncidentOpening(incident?.id, true);
          }}
        >
          {incident?.incidentNumber}
        </button>
      );
      const type = incident?.classification?.name;
      // const uof = incident?.incidentReview?.resistanceType?.id ? "Yes" : "No"
      const location = incident?.address?.name;
      const reviewStatus = incident?.incidentReview?.reviewStatus?.name;
      const approvalStatus = incident?.incidentReview?.approvalStatus?.name;
      const charges = incident?.incidentArrests.filter(
        arrest => arrest?.arrestee?.id
      ).length;
      const reviewDate = incident?.incidentReview?.reviewDate
        ? moment
            .utc(
              incident?.incidentReview?.reviewDate,
              "YYYY-MM-DD HH:mm:ss UTC"
            )
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const showQuickApproval = incident?.classification?.lowLevelFlag;
      const keepInQueue = (
        <Checkbox
          checked={incident?.incidentReview?.keepInQueue}
          onChange={e =>
            keepInQueueMutationHandler(
              incidentIndex,
              incident.id,
              incident.incidentReview?.id,
              e?.target?.checked
            )
          }
          value={"keepInQueue"}
          color="primary"
          data-cy={"keep-in-queue-checkbox"}
          inputProps={{ "data-cy": "keep-in-queue-checkbox-input" }}
        />
      );
      const approve = showQuickApproval ? (
        <Checkbox
          checked={
            incident?.incidentReview?.approvalStatus?.name === "Approved"
          }
          onChange={e =>
            quickApproveHandler(
              incidentIndex,
              incident.id,
              incident.incidentReview?.id,
              e?.target?.checked,
              incident?.incidentReview?.keepInQueue
            )
          }
          value={"approve"}
          color="primary"
          data-cy={"approve-checkbox"}
          inputProps={{ "data-cy": "approve-checkbox-input" }}
        />
      ) : null;
      const supervisorNotes = incident?.incidentReview?.reviewComments;
      tempRows.push(
        createSupervisorData(
          badge,
          callTime,
          incidentNumber,
          type,
          location,
          reviewStatus,
          approvalStatus,
          charges,
          reviewDate,
          keepInQueue,
          approve,
          supervisorNotes,
          callTypeColor,
          locationColor
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createSupervisorData(
  badge,
  callTime,
  incidentNumber,
  type,
  location,
  reviewStatus,
  approvalStatus,
  charges,
  reviewDate,
  keepInQueue,
  approve,
  supervisorNotes,
  callTypeColor,
  locationColor
) {
  return {
    badge,
    callTime,
    incidentNumber,
    type,
    location,
    reviewStatus,
    approvalStatus,
    charges,
    reviewDate,
    keepInQueue,
    approve,
    supervisorNotes,
    callTypeColor,
    locationColor,
  };
}
